export const PERSONAL_INFORMATION = 'personalinformation';
export const DIVERSITY_STATEMENT = 'diversitystatement';
export const RESEARCH_INTERESTS = 'researchinterests';
export const APPLICATION_VALIDATION = 'applicationvalidation';
export const APPLICATION_SUBMISSION = 'applicationsubmission';